<template>
  <div class="container">
    <div class="left-section">
      <h1>{{ $t('home.title') }}</h1>
      <p>
        {{ $t('home.description') }}
        <br />
        <br />
        <span class="dashed-line">{{ $t('home.privacyNote') }}</span>
      </p>
      <button class="trial-button" @click="toDemo">{{ $t('home.startTrial') }}</button>
    </div>
    <div class="right-section">
      <div class="experience-form">
        <h2 class="form-title">{{ $t('home.trialCBAM') }}</h2>

        <div class="form-row">
          <label class="form-label">{{ $t('home.trialName') }}：</label>
          <el-input
            v-model="form.name"
            :placeholder="$t('home.trialName2')"
            class="form-input"
            clearable
          />
        </div>

        <div class="form-row">
          <label class="form-label">{{ $t('home.trialPhone') }}：</label>
          <el-input
            v-model="form.phone"
            :placeholder="$t('home.trialPhone2')"
            class="form-input"
            clearable
          />
        </div>

        <div class="form-row">
          <label class="form-label">{{ $t('home.trialEmail') }}：</label>
          <el-input
            v-model="form.email"
            :placeholder="$t('home.trialEmail2')"
            class="form-input"
            clearable
          />
        </div>


        <el-button class="submit-btn" @click="submitForm">
          {{ $t('home.trialUse') }}
        </el-button>
      </div>
    </div>
    <div class="fixed-bar">
      <el-tooltip class="item-tooltip" placement="left" effect="light">
        <template #content>
          <img src="../../assets/img/carbon/hly-qrcode.png" alt="微信二维码" class="qrcode-image" />
        </template>
        <div class="item">
          <i class="el-icon-chat-dot-round icon-right"></i>
          <span>{{ $t('home.contact.wechat') }}</span>
        </div>
      </el-tooltip>

      <hr />
      <el-tooltip class="item-tooltip" content="15800921098" placement="left" effect="light">
        <div class="item">
          <i class="el-icon-phone icon-right"></i>
          <span>{{ $t('home.contact.phone') }}</span>
        </div>
      </el-tooltip>
      <hr />
      <router-link to="/trial">
        <div class="item">
          <i class="el-icon-data-board icon-right"></i>
          <span>{{ $t('home.contact.demo') }}</span>
        </div>
      </router-link>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: ''
      }
    }
  },
  methods: {
    toDemo() {
      this.$router.push('/trial')
    },
    toRedc(){
      window.open('https://carbon-tc.com/', '_blank')
    },
    toCarbon(){
      window.open('https://carbon-tc.com/', '_blank')
    },
    toCbam(){
      window.open('https://carbon-tc.com/', '_blank')
    },
    toGoldTrade(){
      window.open('https://carbon-tc.com/', '_blank')
    },
    submitForm(){
      window.open('http://test.cbam.1clicktong.com/login', '_blank')
    }
  }
}
</script>

<style lang="scss">
.container {
  display: flex;
  justify-content: space-between;
  padding: 150px 220px 10px 320px;
  background-image: url(../../assets/img/hly/new/首页/first-show.png);
  background-size: cover;
  height: 85vh;
  position: relative;
  z-index: 1;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 5vw 5vw 0 5vw;
  }
}
.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; // 保证视频充满容器
  z-index: -1; // 放在最底层
}

.left-section {
  max-width: 50%;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
}

.left-section h1 {
  font-size: 52px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: normal;
  font-family: "PingFang SC", "Microsoft YaHei", "Source Han Sans", sans-serif;
  @media screen and (max-width: 1440px) {
    font-size:24px;
    font-weight: bold;
  }
  @media screen and (max-width: 768px) {
    font-size: 7.3vw;
  }
}

.left-section p {
  font-size: 23px;
  color: #fff;
  line-height: 1.6;
  @media screen and (max-width: 768px) {
    font-size: 4.5vw;
  }
}
html[lang="en"] .left-section p {
  line-height: 1.4;
}
html[lang="zh"] .left-section p {
  line-height: 1.6;
}
.left-section .dashed-line {
  display: inline-block; /* 保证虚线只作用于这部分文字 */
  border-bottom: 1px dashed #000; /* 设置虚线的样式 */
  padding-bottom: 2px; /* 让文字和虚线之间有一点间距 */
  color: #fff;
  font-size: 22px;
  @media screen and (max-width: 768px) {
    font-size: 4.5vw;
  }
}
.right-section {
  max-width: 40%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 50px;
  margin-right: 200px;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    margin-top: 5vw;
    display: flex;
    justify-content: center;
    order: 2; // 保证它在 .left-section 后
  }
}

.info-card {
  background-color: #212d47;
  color: #fff;
  padding: 40px 32px; // ✅ 增大内边距
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  max-width: 460px; // ✅ 增大最大宽度
  width: 100%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    padding: 24px 20px;
  }
}


.card-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 16px;

  @media screen and (max-width: 768px) {
    font-size: 6vw; // 移动端相对适配
  }
}

.experience-form {
  width: 100%;
  max-width: 460px; // ✅ 增大宽度（你之前设置的是 340）
  margin: 0 auto;
  background: #0c1a2b;
  padding: 40px 30px; // ✅ 更大内边距
  border-radius: 12px;
  color: #fff;
  box-sizing: border-box;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);

  @media screen and (max-width: 768px) {
    display: none;
  }
}


.form-title {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 24px;
  color: #fff;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.form-label {
  color: #fff;
  min-width: 70px; // 统一标签宽度，方便对齐
  font-size: 14px;
  user-select: none; // 不可选中
  padding-right: 10px;
}

.form-input {
  flex: 1;
  .el-input__inner {
  background-color: transparent !important;
  border: none !important;
  border-bottom: 1px solid #ccc !important;
  border-radius: 0 !important;
  color: #fff !important;
  font-size: 14px;
  padding: 4px 0 !important;
}

.el-input__inner::placeholder {
  color: #ccc !important;
}

.el-input__inner:focus {
  border-bottom: 1px solid #3399ff !important;
  box-shadow: none !important;
}

}

.submit-btn {
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
  font-size: 16px;
  padding: 12px 0;
  span{
    color: #0066cc;
    font-weight: bold;
  }
}


.trial-button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  color: #fff;
  background-color: #339216;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  @media screen and (max-width: 768px) {
    margin-top: 2vw;
    font-size: 3.8vw;
  }
}

.text {
  flex-grow: 1; /* 让文字部分自动填充 */
  min-width: 0; /* 避免超出 */
}
.icon {
  font-size: 34px;
  margin-right: 10px;
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.text {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.description {
  font-size: 14px;
  color: #666;
  @media screen and (max-width: 768px) {
    font-size: 2vw;
  }
}


.browse-link {
  display: inline-block;
  margin-top: 20px;
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
}

.browse-link:hover {
  text-decoration: underline;
}

/* 整个固定栏样式 */
.fixed-bar {
  position: fixed;
  right: 0;
  top: 70%;
  transform: translateY(-50%);
  background-color: #339216;
  border-radius: 30px 30px 30px 30px;
  width: 65px; /* 宽度 */
  padding: 10px 0;
  z-index: 1000;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  @media screen and (max-width: 768px) {
    display: none;
  }
}

/* 每个项目的样式 */
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
}

.qrcode-image {
  width: 150px;  /* 你可以调整二维码图像的大小 */
  height: 150px;
}

/* 图标样式 */
.icon-right {
  width: 40px;
  height: 40px;
  margin-bottom: 2px;
  margin-top: 5px;
  color: #fff; /* 图标颜色改为白色 */
  font-size: 34px;
}

/* 分隔线 */
hr {
  width: 80%;
  border: none;
  border-top: 1px solid #fff;
  margin: 5px auto;
}

/* 文本样式 */
span {
  color: #fff;
  font-size: 14px;
}

/* 鼠标悬浮效果 */
.item:hover span {
  text-decoration: underline;
  cursor: pointer;
}

</style>
